module.exports = __webpack_public_path__ + "img/yqc4.934ff74d.jpg";